const preview = () => {
    $(".img-preview").each(function () {
        console.log("vao...")
        const image = $(this).data("image");
        const gif = $(this).data("gif");
        $(this).css({
            "background-image": `url("${image}")`
        });
        $(this).hover(function () {
            $(this).css({
                "background-image": `url("${gif}")`
            });
        }, function () {
            $(this).css({
                "background-image": `url("${image}")`
            });
        })
    })
}

module.exports = preview
